import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1740">
      <Hero data-id="element-1741" />
      <WhyUs data-id="element-1742" />
      <Services data-id="element-1743" />
      <HowItWorks data-id="element-1744" />
      <FAQ data-id="element-1745" />
      <Reviews data-id="element-1746" />
      <CtaBanner data-id="element-1747" />
    </main>;
}